import React, { Component } from 'react';
import {
    Grid,
    Row,
    Col,
    FormControl,
    Form,
    FormGroup,
    ControlLabel,
    Modal
} from 'react-bootstrap';
import SweetAlert from "react-bootstrap-sweetalert";
import Card from '../../components/Card/Card.jsx';
import Button from '../../elements/CustomButton/CustomButton.jsx';
import { mountTable, unmountTable, getTable } from '../../views/Components/JQueryTable/JQueryTableLogic.jsx';
import JQueryTableComponent from '../../views/Components/JQueryTable/JQueryTableComponent.jsx';
import { API_ROOT } from '../../variables/api-config';
import ProyectService from '../../services/ProyectService';
import ModalBlockWrapper from '../Components/ModalBlockWrapper';

const dataTable = {
  headerRow: ["Id", "Nombre", "Descripción", "Responsable", "Creacion", "Editar"],
  footerRow: ["Id", "Nombre", "Descripción", "Responsable", "Creacion", "Editar"],
};

class Main extends Component{
  constructor(props){
    super(props);
    this.state = {
        alert: null,
        nombre: null,
        descripcion: null,
    };
    this.projectService = new ProyectService();
    this.handleSelect = this.handleSelect.bind(this);
    this.errorAlert = this.errorAlert.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.editAction = this.editAction.bind(this);
    this.createProject = this.createProject.bind(this);
  }

  componentDidMount() {
    mountTable(API_ROOT + "/project/list", "proyectosTable", this.editAction);
  }

  componentWillUnmount() {
    unmountTable('proyectosTable');
  }
  shouldComponentUpdate() {
    return true;
  }

  editAction(data) {
    this.props.history.push("/project-management/edit/" + data[0]);
  }

  createProject() {
    const project = {
      nombre: this.state.nombre,
      descripcion: this.state.descripcion,
      id: null,
    };
    this.projectService
      .editProject(project)
      .then(res => {
        const table = getTable('proyectosTable');
        table.clear();
        table.ajax.reload();
        table.draw();
        this.setState({
          alert: (
            <SweetAlert
              success
              style={{ display: "block", marginTop: "-100px" }}
              title="Listo!"
              onConfirm={() => this.hideAlert()}
              onCancel={() => this.hideAlert()}
              confirmBtnBsStyle="info"
              confirmBtnText="Aceptar"
            >
              Proyecto creado exitosamente!
            </SweetAlert>
          ),
          nombre: null,
          descripcion: null,
          modalCreate: null,
        });
      })
      .catch(err => {
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se guardaban los datos, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }

  hideAlert() {
    this.setState({
      alert: null
    });
  }
  handleSelect(key){
    this.setState({key});
  }
  errorAlert(message) {
    this.setState({
      alert: (
        <SweetAlert
          error
          style={{ display: "block", marginTop: "-100px" }}
          title="Error"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="danger"
          confirmBtnText="Aceptar"
        >
          {message}
        </SweetAlert>
      )
    });
  }
  render(){
    return (
      <div className="main-content">
        {this.state.alert}
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Proyectos"
                content={
                  <div>
                    <div style={{ paddingBottom: 10 + "px", textAlign: "right" }}>
                      <Button bsStyle="primary" bsSize="sm" fill wd onClick={() => this.setState({modalCreate: true})}>
                        Nuevo proyecto
                      </Button>
                    </div>
                    <div className="fresh-datatables">
                      <JQueryTableComponent dataTable={dataTable} identifier="proyectosTable" />
                    </div>
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
        {this.state.modalCreate &&
          <Modal show onHide={() => this.setState({modalCreate: false, nombre: null, descripcion: null})} style={{ display: "block" }}>
            <ModalBlockWrapper
              content={
                <div>
                  <Modal.Header closeButton>
                    <Modal.Title>Nuevo Proyecto</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Row>
                      <Col md={12}>
                        <Form>
                          <FormGroup>
                            <ControlLabel>{'Nombre'}</ControlLabel>
                            <FormControl
                              type="text"
                              value={this.state.nombre ? this.state.nombre : ''}
                              onChange={(e) => this.setState({nombre: e.target.value})}
                            />
                          </FormGroup>
                        </Form>
                      </Col>
                      <Col md={12}>
                        <Form>
                          <FormGroup>
                            <ControlLabel>{'Descripcion'}</ControlLabel>
                            <FormControl
                              componentClass="textarea" type="text" style={{height: 120}}
                              value={this.state.descripcion ? this.state.description : ''}
                              onChange={(e) => this.setState({descripcion: e.target.value})}
                            />
                          </FormGroup>
                        </Form>
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button simple onClick={() => this.setState({modalCreate: false, nombre: null, descripcion: null})}>
                      Cancelar
                    </Button>
                    <Button
                      bsStyle="success" fill onClick={this.createProject}
                    >
                      Guardar
                    </Button>
                  </Modal.Footer>
                </div>
              }
            />
          </Modal>
          }
      </div>
    );
  }
}
export default Main;



// WEBPACK FOOTER //
// ./src/views/ProjectManagement/Main.jsx